module.exports = __webpack_public_path__ + "img/23-3.a3b63427.png";